<template>
  <div class="register-verification">
    <h1 class="register-title">{{ $t('verification') }}</h1>
    <p class="register-sub-title">{{ $t('enterSendCode') }}</p>

    <InputCode
      :password="form.authCode"
      :pass-number="true"
      :is-error="!!codeInputError"
      @click="handleInput"
    />

    <LinkButton
      :decoration="false"
      class="re-send-button"
      :disabled="countdown !== 0 || resendDisabled"
      @click="handleResendCode"
    >
      {{ computedSendBtnText }}
    </LinkButton>

    <div class="error-view">{{ codeInputError }}</div>

    <md-number-keyboard
      v-model="showBoard"
      is-hide-confirm
      type="simple"
      hide-dot
      @enter="handleEnterValue"
      @delete="handleDeleteValue"
    />
  </div>
</template>

<script>
import InputCode from '@/components/InputCode'
import LinkButton from '@/components/LinkButton'
import { NumberKeyboard, Toast } from 'mand-mobile'
import { userLogin, smsLogin } from '@/api/register'
import global from '@/utils/global'

function formatTimer (time) {
  if (`${time}`.length < 2) {
    return `0${time}`
  }

  return time
}

function secondToDate (result) {
  const m = formatTimer(Math.floor((result / 60 % 60)))
  const s = formatTimer(Math.floor((result % 60)))
  return `${m}:${s}`
}

const COUNTDOWN = 60

export default {
  name: 'RegisterVerification',

  components: {
    InputCode,
    LinkButton,
    [NumberKeyboard.name]: NumberKeyboard
  },

  data () {
    this.countdownTimer = null
    return {
      showBoard: true,
      resendDisabled: false,
      countdown: COUNTDOWN,
      form: {
        authCode: '',
        mobile: ''
      },
      codeInputError: ''
    }
  },

  computed: {
    computedCountdown () {
      return secondToDate(this.countdown)
    },

    computedSendBtnText () {
      return this.countdown === 0 ? this.$t('resend_code') : this.$t('resendCode', { s: this.computedCountdown })
    }
  },

  destroyed () {
    clearInterval(this.countdownTimer)
  },

  created () {
    this.form.mobile = this.$route.params.mobile
    if (!this.form.mobile) {
      return this.$router.replace({ name: 'Register' })
    }

    this.createCountdown()
  },

  methods: {
    createCountdown () {
      this.countdown = COUNTDOWN

      this.countdownTimer = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.countdownTimer)
          return
        }

        this.countdown--
      }, 1000)
    },
    handleInput () {
      this.showBoard = true
      this.codeInputError = ''
    },
    handleEnterValue (value) {
      this.codeInputError = ''
      if (this.form.authCode.length >= 6) return
      this.form.authCode = `${this.form.authCode}${value}`

      if (this.form.authCode.length >= 6) {
        this.codeInputError = ''
        userLogin(this.form)
          .then(result => {
            // token.setToken(result.token)
            global.setCookie('FLP-USER-TOKEN', result.token)

            this.$router.replace({ name: 'Home' })
          })
          .catch((error) => {
            this.codeInputError = error.message
          })
      }
    },
    handleDeleteValue () {
      this.codeInputError = ''
      this.form.authCode = this.form.authCode.substring(0, this.form.authCode.length - 1)
    },
    // 重新发送验证码
    async handleResendCode () {
      this.resendDisabled = true
      smsLogin({ mobile: this.form.mobile })
        .then(() => {
          this.createCountdown()
        })
        .finally(() => {
          this.resendDisabled = false
        })

      // 重新发送成功
      Toast.succeed(this.$t('resendSucc'))
    }
  }
}
</script>

<style scoped>
.register-title {
  font-size: 48px;
  margin-bottom: 24px;
}

.register-sub-title {
  margin-bottom: 112px;
  font-size: 32px;
  color: #7f7f7f;
}

.register-verification {
  padding: 120px 40px;
}

.re-send-button {
  display: block;
  margin-top: 34px;
}

.error-view {
  margin-top: 88px;
  text-align: center;
  color: #fa5151;
}
</style>
